import styled from 'styled-components'

import { Colours } from '@/utils/styles'

type StyleTypes = 'danger' | 'primary' | 'warning'

function getColourFromStyleType(style?: StyleTypes) {
  switch (style) {
    case 'danger':
      return Colours.red
    case 'warning':
      return Colours.orange
    case 'primary':
    default:
      return Colours.blue
  }
}

interface Props {
  styleType?: StyleTypes
}

const SmallPill = styled.button<Props>`
  padding: 10px;
  cursor: pointer;
  background: transparent;
  border-radius: 10px;
  border-color: ${(props: Props) => getColourFromStyleType(props.styleType)};
  border: 1px solid;
  width: fit-content;
  display: block;
  letter-spacing: 0.23px;
  color: ${(props: Props) => getColourFromStyleType(props.styleType)};
  font:
    bold 15px Lato,
    sans-serif;
  outline: none;
  text-decoration: none;

  &:disabled {
    background: #f2f2f2;
    border-color: #f2f2f2;
  }
`
export default SmallPill
